import posthog from "posthog-js";

export default {
  install(Vue) {
    Vue.prototype.$posthog = posthog.init(
      "phc_XFRsFr6qMKEU8AFUXjXbdDHId0hdZ7h9UAAlprr8TxN",
      {
        api_host: "https://eu.i.posthog.com"
      }
    );
  }
};
